// removed by extract-text-webpack-plugin
module.exports = {"container":"_9AJnV","avatar-wrapper":"_38bB9","avatar":"_1yCh5","date":"_3LUF5","content-wrapper":"_1pKrG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichUpdates/RichUpdatesTimelineItem/RichUpdatesTimelineItem.scss
// module id = ./src/components/RichUpdates/RichUpdatesTimelineItem/RichUpdatesTimelineItem.scss
// module chunks = 5